import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import { authGuard } from "@/common/auth-guard";
import HomeView from "../views/HomeView.vue";
import System from "../components/system/Index.vue";
import Member from "../components/system/Member.vue"; // Account management
import Role from "../components/system/Role.vue"; // Role management
import Menu from "../components/system/Menu.vue"; // Menu configuration


/** Logs */
import OperateLogs from "../components/system/OperateLogs.vue"; // Operation logs
import LoginLogs from "../components/system/LoginLogs.vue"; // Login logs
import DataChangesLogs from "../components/system/DataChangesLogs.vue"; // Data change logs

/** New equipment diagnosis */
import Overview from "../components/diagnosis/overview.vue"; // Equipment health overview
import SensorN from "../components/diagnosis/sensor.vue"; // Equipment health overview


/** Alarm management */
import SmartAlarm from "../components/system/SmartAlarm.vue"; // Status monitoring alarms
import DiagnosisWaring from "../components/system/DiagnosisWaring.vue"; // Status monitoring alarms
import RuleSetting from "../components/system/RuleSetting.vue"; // Basic settings


/** Status monitoring */
import SensorMonitoring from "../components/system/SensorMonitoring.vue"; // Sensor monitoring
import SoftwareMonitoring from "../components/system/SoftwareMonitoring.vue"; // Software monitoring

/** Knowledge base */
import Metric from "../components/knowledge/metric.vue"


// Dashboards
import cliqueDashboard from "../components/dashboard/clique.vue"  // Group dashboard
import factoryDashboard from "../components/dashboard/factory.vue"  // Factory dashboard
import machineDashboard from "../components/dashboard/machine.vue"  // Machine dashboard

// Equipment management
import Equipment from "../components/equipment/equipment.vue"

// Alarm management
import WarningList from "../components/warning-manage/warning-list.vue"

// Reports
import ReportList from "../components/report4/list.vue"
import ReportTemplate from "../components/report4/template.vue"
import MWReportInfo from "../components/report4/MWReportInfo.vue"

// Knowledge base
import KnowledgeFault from "../components/knowledge/fault.vue"
import KnowledgeModel from "../components/knowledge/model.vue"
import KnowledgeTranslation from "../components/knowledge/translations.vue"

import factoryModel from "../components/system/factory.vue"

// Power on/off
import onModel from "../components/system/On.vue"

import { codeGuard } from "@/common/code-guard";

// Acquisition unit monitoring
import DigitizerMonitor from '@/components/system/digitizerMonitor.vue';
// Hardware monitoring alarms
import HardwareWarning from '@/components/warning-manage/hardware-warning.vue';


import { menuGuard } from "@/common/menu-guard";

let diagnosisGuards: any[] = [() => {return true;}];
if (process.env.NODE_ENV === 'production') {
    diagnosisGuards = [codeGuard];
}

const routes: RouteRecordRaw[] = [
    {
        path: "/",
        beforeEnter: authGuard,
        component: HomeView,
        children: [
            // { path: "dashboard", component: Dashboard },
            {
                path: "dashboard",
                redirect: "/dashboard/clique",
                children: [
                    { path: "clique", component: cliqueDashboard, beforeEnter: menuGuard },
                    { path: "factory", component: factoryDashboard, beforeEnter: menuGuard },
                    { path: "machine", component: machineDashboard, beforeEnter: menuGuard },
                ]
            },

            {
                path: "diagnosisN",
                redirect: "/diagnosisN/overview",
                children: [
                    { path: "overview", component: Overview, beforeEnter: menuGuard },
                    { path: "sensor", component: SensorN, beforeEnter: menuGuard }
                ],
            },

            {
                path: "equipment",
                redirect: "/equipment/list",
                children: [
                    { path: "list", component: Equipment, beforeEnter: menuGuard },
                ],
            },

            {
                path: "warning-manage",
                redirect: "/warning-manage/warning-list",
                children: [
                    { path: "warning-list", component: WarningList, beforeEnter: menuGuard },
                    // Hide expert care configuration in the alarm management smart diagnosis configuration
                    {
                        path: "diagnosisWaring",
                        component: DiagnosisWaring,
                        props: { hideExpertCareOptions: true },
                        beforeEnter: menuGuard
                    },
                    // Hide expert care configuration in the alarm management metric alarm configuration
                    {
                        path: "smartAlarm",
                        component: SmartAlarm,
                        props: { hideExpertCareOptions: true },
                        beforeEnter: menuGuard
                    },
                    { path: "hardwareWarning", component: HardwareWarning, beforeEnter: menuGuard },

                ],
            },

            {
                path: "report",
                redirect: "/report/list",
                children: [
                    { path: "list", component: ReportList, beforeEnter: menuGuard },
                    { path: "mwDetail/:id", component: MWReportInfo },
                    { path: "template", component: ReportTemplate, beforeEnter: menuGuard },
                ],
            },

            {
                path: "knowledge",
                redirect: "/knowledge/fault",
                children: [
                    { path: "fault", component: KnowledgeFault, beforeEnter: menuGuard },
                    { path: "model", component: KnowledgeModel, beforeEnter: menuGuard },
                    { path: "translation", component: KnowledgeTranslation, beforeEnter: menuGuard },
                    
                ],
            },
            {
                path: "system",
                redirect: "/system/role",
                component: System,
                children: [
                    { path: "member", component: Member, beforeEnter: menuGuard },
                    { path: "role", component: Role, beforeEnter: menuGuard },
                    { path: "menu", component: Menu, beforeEnter: menuGuard },
                    { path: "factory", component: factoryModel, beforeEnter: menuGuard },
                    { path: "diagnosisWaring", component: DiagnosisWaring, beforeEnter: diagnosisGuards },
                    { path: "smartAlarm", component: SmartAlarm, beforeEnter: diagnosisGuards },
                    { path: "ruleSetting", component: RuleSetting },
                    // Legacy/menu alias for OPC data push settings; points to RuleSetting page.
                    { path: "opc-data-push-setting", component: RuleSetting },
                    { path: "on", component: onModel, beforeEnter: diagnosisGuards },
                    { path: "operateLogs", component: OperateLogs, beforeEnter: menuGuard },
                    { path: "loginLogs", component: LoginLogs, beforeEnter: menuGuard },
                    { path: "dataChangesLogs", component: DataChangesLogs, beforeEnter: menuGuard },
                    { path: "sensorMonitoring", component: SensorMonitoring, beforeEnter: menuGuard },
                    { path: "softwareMonitoring", component: SoftwareMonitoring, beforeEnter: menuGuard },
                    { path: "digitizerMonitoring", component: DigitizerMonitor, beforeEnter: menuGuard },

                ],
            },

            { path: "", redirect: "dashboard" },
            { path: "metric", component: Metric },

        ],
    },
    {
        path: "/login",
        name: "login",
        component: () => import("../views/LoginView.vue"),
    },
    {
        path: "/code-valid",
        name: "code-valid",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import("../views/CodeValidView.vue"),
    },
    {
        path: "/week-report/:id",
        name: "week-report",
        component: () => import("../components/output/week-report.vue"),
    },
    {
        path: "/week-report-mobile/:id",
        name: "week-report-mobile",
        component: () => import("../components/output/week-report-mobile.vue"),
    },
    { path: "/forbidden-403", component: () => import("../views/forbidden-403.vue") }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;
